@for (track of tracks; track track; let i = $index) {
    <div
        [ngClass]="{
            'flex-1': tracks?.length > 1 && i < tracks.length - 1,
        }">
        <div class="flex relative">
            <div
                [ngClass]="{
                    'font-bold':
                        i <= currentTrack.index ||
                        (currentTrack.index === -1 && i === 0),
                    edge: (i === 0 || i === tracks.length - 1) && wrapLabel,
                }"
                [style.color]="
                    currentTrack.index > i
                        ? completeSectionTextColour
                        : textColour
                "
                class="absolute mt-5 sm:mt-6 label"></div>
        </div>
        @if (tracks?.length > 1 && i < tracks.length - 1) {
            <div class="flex items-center flex-1 track-bar">
                <div
                    [style.backgroundColor]="secondaryColour"
                    class="inner-track"></div>
                <div
                    [ngStyle]="{
                        width:
                            i < currentTrack.index
                                ? '100%'
                                : i === currentTrack.index ||
                                    (currentTrack.index === -1 && i === 0)
                                  ? percentage
                                  : '0',
                    }"
                    [style.backgroundColor]="primaryColour"
                    class="track-progress"></div>
            </div>
        }
    </div>
}
